import React, { useState, useEffect } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import searchIcon from '../../assets/Icon/search_icon.svg';
import { apiService } from '../../services/apiService';
import Loader from '../../CommanService/Loader';
import './RevenueComponent.css';

const RevenueComponent = () => {
  // State for filter options
  const [regions, setRegions] = useState([]);
  const [interchangeNumbers, setInterchangeNumbers] = useState([]);
  const [partTypes, setPartTypes] = useState([]);
  
  // Selected values state
  const [selectedRegions, setSelectedRegions] = useState(['All']);
  const [selectedPartTypes, setSelectedPartTypes] = useState(['All']);
  const [selectedInterchangeNumbers, setSelectedInterchangeNumbers] = useState(['All']);
  
  // Applied filters state (for search button functionality)
  const [appliedFilters, setAppliedFilters] = useState({
    partTypes: ['All'],
    regions: ['All'],
    interchangeNumbers: ['All'],
    startDate: '',
    endDate: ''
  });

  // Historical sales data state
  const [historicalSalesData, setHistoricalSalesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);

  // Date filter state for Period 2 (last year's same month)
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    // Get last year's same month, 1st day
    const lastYear = today.getFullYear() - 1;
    const month = today.getMonth(); // 0-indexed (0=January, 11=December)
    const firstDayOfMonth = new Date(lastYear, month, 1);
    
    // Format as YYYY-MM-DD
    const yearStr = firstDayOfMonth.getFullYear();
    const monthStr = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
    const dayStr = String(firstDayOfMonth.getDate()).padStart(2, '0');
    
    return `${yearStr}-${monthStr}-${dayStr}`;
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    // Get last year's same month, last day
    const lastYear = today.getFullYear() - 1;
    const month = today.getMonth(); // 0-indexed (0=January, 11=December)
    const lastDayOfMonth = new Date(lastYear, month + 1, 0); // Day 0 of next month = last day of current month
    
    // Format as YYYY-MM-DD
    const yearStr = lastDayOfMonth.getFullYear();
    const monthStr = String(lastDayOfMonth.getMonth() + 1).padStart(2, '0');
    const dayStr = String(lastDayOfMonth.getDate()).padStart(2, '0');
    
    return `${yearStr}-${monthStr}-${dayStr}`;
  });

  // Period 1 date filter state (current month from 1st to current date)
  const [startDate2, setStartDate2] = useState(() => {
    const today = new Date();
    // Get the first day of current month
    const year = today.getFullYear();
    const month = today.getMonth(); // 0-indexed (0=January, 11=December)
    const firstDayOfMonth = new Date(year, month, 1);
    
    // Format as YYYY-MM-DD
    const yearStr = firstDayOfMonth.getFullYear();
    const monthStr = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
    const dayStr = String(firstDayOfMonth.getDate()).padStart(2, '0');
    
    return `${yearStr}-${monthStr}-${dayStr}`;
  });
  const [endDate2, setEndDate2] = useState(() => {
    const today = new Date();
    // Format as YYYY-MM-DD
    const yearStr = today.getFullYear();
    const monthStr = String(today.getMonth() + 1).padStart(2, '0');
    const dayStr = String(today.getDate()).padStart(2, '0');
    
    return `${yearStr}-${monthStr}-${dayStr}`;
  });


  const formatNumber = (num) => {
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  const formatNumber1 = (num) => {
    if (num === null || num === undefined) return "";
    return new Intl.NumberFormat('en-IN').format(num);
  }



  // Fetch historical sales data on component mount
  useEffect(() => {
    const fetchHistoricalSales = async () => {
      try {
        setLoading(true);
        const response = await apiService.GethistoricalSales(true);
         
        if (response && response.data) {
          setHistoricalSalesData(response.data);
          console.log('Historical Sales Data loaded:', response.data);
          
                     // Extract unique values for dropdowns and add "All" option
           const uniqueRegions = ['All', ...new Set(response.data.map(item => item.region).filter(Boolean))];
           const uniqueInterchanges = ['All', ...new Set(response.data.map(item => item.interchange_number).filter(Boolean))];
           const uniquePartName = ['All', ...new Set(response.data.map(item => item.part_name || item.part_type).filter(Boolean))];
           
           setRegions(uniqueRegions);
           setInterchangeNumbers(uniqueInterchanges);
           setPartTypes(uniquePartName);
           
           // Always start with "All" for all filters
           setSelectedRegions(['All']);
           setSelectedPartTypes(['All']);
           setSelectedInterchangeNumbers(['All']);
          
          console.log('Revenue Component initialized with API data');
                     console.log('Available Part Types:', uniquePartName);
           console.log('Available Regions:', uniqueRegions);
           console.log('Available IC Numbers:', uniqueInterchanges);
        }
                    } catch (error) {
         console.error('Error fetching historical sales data:', error);
         // Set empty data when API fails
         setHistoricalSalesData([]);
         setRegions(['All']);
         setInterchangeNumbers(['All']);
         setPartTypes(['All']);
         
         // Always start with "All" for all filters
         setSelectedRegions(['All']);
         setSelectedPartTypes(['All']);
         setSelectedInterchangeNumbers(['All']);
       } finally {
         setLoading(false);
       }
    };

    fetchHistoricalSales();
  }, []);

  // Function to update Region and IC Number dropdowns based on selected Part Types
  const updateDropdownsBasedOnPartTypes = (selectedPartTypes) => {
    if (!historicalSalesData.length) return;

    if (selectedPartTypes.includes('All')) {
      // If "All" is selected, show all regions and IC numbers
      const uniqueRegions = ['All', ...new Set(historicalSalesData.map(item => item.region).filter(Boolean))];
      const uniqueInterchanges = ['All', ...new Set(historicalSalesData.map(item => item.interchange_number).filter(Boolean))];
      setRegions(uniqueRegions);
      setInterchangeNumbers(uniqueInterchanges);
    } else {
      // Filter data by selected part types
      const filteredByPartTypes = historicalSalesData.filter(item => 
        selectedPartTypes.some(partType => 
          (item.part_name === partType) || (item.part_type === partType)
        )
      );
      
      // Extract unique regions and IC numbers from filtered data
      const uniqueRegions = ['All', ...new Set(filteredByPartTypes.map(item => item.region).filter(Boolean))];
      const uniqueInterchanges = ['All', ...new Set(filteredByPartTypes.map(item => item.interchange_number).filter(Boolean))];
      
      setRegions(uniqueRegions);
      setInterchangeNumbers(uniqueInterchanges);
    }
  };

  // Function to update IC Number dropdown based on selected Region
  const updateICNumbersBasedOnRegion = (selectedRegions) => {
    if (!historicalSalesData.length) return;

    if (selectedRegions.includes('All')) {
      // If "All" is selected, show IC numbers based on current part types filter
      let filteredData = historicalSalesData;
      
      if (!selectedPartTypes.includes('All')) {
        filteredData = historicalSalesData.filter(item => 
          selectedPartTypes.some(partType => 
            (item.part_name === partType) || (item.part_type === partType)
          )
        );
      }
      
      const uniqueInterchanges = ['All', ...new Set(filteredData.map(item => item.interchange_number).filter(Boolean))];
      setInterchangeNumbers(uniqueInterchanges);
    } else {
      // Filter data by selected regions and part types
      let filteredData = historicalSalesData.filter(item => 
        selectedRegions.some(region => item.region === region)
      );
      
      if (!selectedPartTypes.includes('All')) {
        filteredData = filteredData.filter(item => 
          selectedPartTypes.some(partType => 
            (item.part_name === partType) || (item.part_type === partType)
          )
        );
      }
      
      const uniqueInterchanges = ['All', ...new Set(filteredData.map(item => item.interchange_number).filter(Boolean))];
      setInterchangeNumbers(uniqueInterchanges);
    }
  };

  // Get filtered data based on applied filters and date range
  const getFilteredData = (startDateFilter, endDateFilter) => {
    if (!historicalSalesData.length) return [];
    
    let filteredData = historicalSalesData;
    
    // First apply the dropdown filters (only if search has been clicked and filters are applied)
    if (appliedFilters.partTypes && !appliedFilters.partTypes.includes('All')) {
      filteredData = filteredData.filter(item => 
        appliedFilters.partTypes.some(partType => 
          (item.part_name === partType) || (item.part_type === partType)
        )
      );
    }
    
    if (appliedFilters.regions && !appliedFilters.regions.includes('All')) {
      filteredData = filteredData.filter(item => 
        appliedFilters.regions.some(region => item.region === region)
      );
    }
    
    if (appliedFilters.interchangeNumbers && !appliedFilters.interchangeNumbers.includes('All')) {
      filteredData = filteredData.filter(item => 
        appliedFilters.interchangeNumbers.some(icNumber => item.interchange_number === icNumber)
      );
    }
    
    // Then filter by date range if dates are provided
    if (startDateFilter && endDateFilter) {
      filteredData = filteredData.filter(item => {
        if (!item.invoice_date) return false;
        const invoiceDate = new Date(item.invoice_date);
        // Normalize to include the full start and end days
        const startDate = new Date(startDateFilter);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(endDateFilter);
        endDate.setHours(23, 59, 59, 999);
        return invoiceDate >= startDate && invoiceDate <= endDate;
      });
    }
    
    return filteredData;
  };

  // Calculate revenue metrics for a given dataset
  const calculateRevenueMetrics = (data) => {
    if (!data || data.length === 0) {
      return {
        revenue: 0,
        pricePerUnit: 0,
        quantitySold: 0
      };
    }
    
    const totalRevenue = data.reduce((sum, item) => sum + (item.all_parts_gross_sales || 0), 0);
    const quantitySold = data.length;
    const pricePerUnit = quantitySold > 0 ? totalRevenue / quantitySold : 0;
    
    return {
      revenue: totalRevenue,
      pricePerUnit: Math.round(pricePerUnit * 100) / 100, // Round to 2 decimal places
      quantitySold: quantitySold
    };
  };

    // Handle search button click
  const handleSearch = async () => {
    setSearchLoading(true);
    try {
      // Apply the current selections as filters
      setAppliedFilters({
        partTypes: selectedPartTypes,
        regions: selectedRegions,
        interchangeNumbers: selectedInterchangeNumbers,
        startDate: startDate,
        endDate: endDate
      });
      
      // Simulate a small delay to show loading state for better UX
      await new Promise(resolve => setTimeout(resolve, 500));
    } finally {
      setSearchLoading(false);
    }
  };

  // Handle dropdown selection with "All" logic
  const handleSelect = (selectedList, selectedItem, setSelectedValues) => {
    // If "All" is selected, clear other selections
    if (selectedItem === 'All') {
      setSelectedValues(['All']);
      
      // Update dropdowns when "All" is selected
      if (setSelectedValues === setSelectedPartTypes) {
        updateDropdownsBasedOnPartTypes(['All']);
      } else if (setSelectedValues === setSelectedRegions) {
        updateICNumbersBasedOnRegion(['All']);
      }
    } else {
      // If a specific item is selected, remove "All" from the list
      const filteredList = selectedList.filter(item => item !== 'All');
      setSelectedValues(filteredList);
      
      // Update dropdowns when specific items are selected
      if (setSelectedValues === setSelectedPartTypes) {
        updateDropdownsBasedOnPartTypes(filteredList);
      } else if (setSelectedValues === setSelectedRegions) {
        updateICNumbersBasedOnRegion(filteredList);
      }
    }
  };

  // Handle dropdown removal with "All" logic
  const handleRemove = (selectedList, removedItem, setSelectedValues, options) => {
    // If "All" is being removed, do nothing (keep "All" selected)
    if (removedItem === 'All') {
      return;
    }
    
    // If no items are left after removal, select "All"
    if (selectedList.length === 0) {
      setSelectedValues(['All']);
      
      // Update dropdowns when "All" is selected
      if (setSelectedValues === setSelectedPartTypes) {
        updateDropdownsBasedOnPartTypes(['All']);
      } else if (setSelectedValues === setSelectedRegions) {
        updateICNumbersBasedOnRegion(['All']);
      }
    } else {
      setSelectedValues(selectedList);
      
      // Update dropdowns based on remaining selections
      if (setSelectedValues === setSelectedPartTypes && selectedList.length > 0) {
        updateDropdownsBasedOnPartTypes(selectedList);
      } else if (setSelectedValues === setSelectedRegions && selectedList.length > 0) {
        updateICNumbersBasedOnRegion(selectedList);
      }
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="revenue-container">
      <div className="filter_section d-flex align-items-start row mb_25">
                 <div className="filter_items col-md-3">
                       <label className="font_14 fw-med text_black">
              Part Type
            </label>
           <Multiselect
             isObject={false}
             options={partTypes}
             selectedValues={selectedPartTypes}
             onSelect={(selectedList, selectedItem) => {
               handleSelect(selectedList, selectedItem, setSelectedPartTypes);
             }}
             onRemove={(selectedList, removedItem) => {
               handleRemove(selectedList, removedItem, setSelectedPartTypes, partTypes);
             }}
             placeholder="Select Part Type"
           />
         </div> 

                 <div className="filter_items col-md-3">
                       <label className="font_14 fw-med text_black">
              Regions
            </label>
           <Multiselect
             isObject={false}
             options={regions}
             selectedValues={selectedRegions}
             onSelect={(selectedList, selectedItem) => {
               handleSelect(selectedList, selectedItem, setSelectedRegions);
             }}
             onRemove={(selectedList, removedItem) => {
               handleRemove(selectedList, removedItem, setSelectedRegions, regions);
             }}
             placeholder="Select Regions"
           />
         </div>
         
                 <div className="filter_items col-md-3">
                       <label className="font_14 fw-med text_black">
              IC Number
            </label>
           <Multiselect
             isObject={false}
             options={interchangeNumbers}
             selectedValues={selectedInterchangeNumbers}
             onSelect={(selectedList, selectedItem) => {
               handleSelect(selectedList, selectedItem, setSelectedInterchangeNumbers);
             }}
             onRemove={(selectedList, removedItem) => {
               handleRemove(selectedList, removedItem, setSelectedInterchangeNumbers, interchangeNumbers);
             }}
             placeholder="Select IC Number"
           />
         </div>
        
        
        
                           <div className="filter_button_blk mt_26">
            {searchLoading ? (
              <div className="search-loading">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <img 
                src={searchIcon} 
                alt="search" 
                className="search-icon" 
                onClick={handleSearch}
              />
            )}
          </div>
        </div>

        {/* Two Period Comparison Section */}
        <div className="period-comparison-section mb_25">
          <div className="period-row custom_row">
            {/* Period 1 */}
            <div className="period-divider mr_12">
              <div className="period-section">
                <h3 className="period-title">Period 1</h3>
                
                <div className="date-fields m-0">
                   <div className="date-row">
                     <div className="date-field">
                       <label className="font_16 fw-med text_black">Start Date</label>
                       <input
                         type="date"
                         className="form-control"
                         value={startDate2}
                         onChange={(e) => setStartDate2(e.target.value)}
                       />
                     </div>
                     
                     <div className="date-field">
                       <label className="font_16 fw-med text_black">End Date</label>
                       <input
                         type="date"
                         className="form-control"
                         value={endDate2}
                         onChange={(e) => setEndDate2(e.target.value)}
                       />
                     </div>
                   </div>
                 </div>

                 <div className="metrics-row">
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Revenue</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate2, endDate2);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return `${formatNumber(metrics.revenue)} $`;
                       })()}
                     </div>
                   </div>
                   
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Price Per Unit</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate2, endDate2);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return `${formatNumber(metrics.pricePerUnit)} $`;
                       })()}
                     </div>
                   </div>
                   
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Total qty sold</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate2, endDate2);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return formatNumber1(metrics.quantitySold);
                       })()}
                     </div>
                   </div>
                 </div>
              </div>
            </div>

            {/* Vertical Divider */}
            <div className="vertical-divider"></div>

            {/* Period 2 */}
            <div className="period-divider">
              <div className="period-section">
                <h3 className="period-title">Period 2</h3>
                
                                 <div className="date-fields m-0">
                   <div className="date-row">
                     <div className="date-field">
                       <label className="font_16 fw-med text_black">Start Date</label>
                       <input
                         type="date"  
                         className="form-control"
                         value={startDate}
                         onChange={(e) => setStartDate(e.target.value)}
                       />
                     </div>
                     
                     <div className="date-field">
                       <label className="font_16 fw-med text_black">End Date</label>
                       <input
                         type="date"
                         className="form-control"
                         value={endDate}
                         onChange={(e) => setEndDate(e.target.value)}
                       />
                     </div>
                   </div>
                 </div>

                 <div className="metrics-row">
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Revenue</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate, endDate);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return `${formatNumber(metrics.revenue)} $`;
                       })()}
                     </div>
                   </div>
                   
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Price Per Unit</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate, endDate);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return `${formatNumber(metrics.pricePerUnit)} $`;
                       })()}
                     </div>
                   </div>
                   
                   <div className="metric-item">
                     <label className="font_16 fw-med text_black">Total qty sold</label>
                     <div className="metric-value">
                       {(() => {
                         const filteredData = getFilteredData(startDate, endDate);
                         const metrics = calculateRevenueMetrics(filteredData);
                         return formatNumber1(metrics.quantitySold);   
                       })()}
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
      
         
        
    </div>
  );
};

export default RevenueComponent;
